export function extractContext(messages, targetId) {
  const index = messages.findIndex((m) => m.id === targetId);
  if (index === -1) return null;

  // 1. Buscar el último bloque anterior de mensajes consecutivos del usuario
  const previousUserMessages = [];
  let foundUserBlock = false;

  for (let i = index - 1; i >= 0; i--) {
    const msg = messages[i];

    if (!foundUserBlock) {
      if (msg.right === false) {
        foundUserBlock = true;
        previousUserMessages.unshift(msg);
      }
    } else {
      if (msg.right === false) {
        previousUserMessages.unshift(msg);
      } else {
        break;
      }
    }
  }

  // 2. Buscar todos los mensajes consecutivos del bot alrededor del mensaje actual
  const concurrentBotMessages = [];

  // hacia atrás desde el índice
  for (let i = index; i >= 0; i--) {
    const msg = messages[i];
    if (msg.right === true) {
      concurrentBotMessages.unshift(msg); // agregar al principio para mantener orden
    } else {
      break;
    }
  }

  // hacia adelante desde el siguiente mensaje
  for (let i = index + 1; i < messages.length; i++) {
    const msg = messages[i];
    if (msg.right === true) {
      concurrentBotMessages.push(msg);
    } else {
      break;
    }
  }

  return {
    previousUserMessages,
    concurrentBotMessages,
  };
}
